import React from "react";
import PropTypes from "prop-types";
import { sizes, srcset } from "../../../helpers/image";
import { Grid, Item } from "../ThreeColumn";
import Teaser from "../Teaser";

const List = ({ newsList }) => {
  const width = 570;
  const imageSizes = sizes(width, 3);

  return (
    <Grid gap="wide">
      {newsList.map((news, i) => {
        const imageSrcset = srcset(
          width,
          news.image_retina,
          news.image_default
        );
        const isExternal = news.type === "external";

        return (
          <Item key={news.id}>
            <Teaser
              label={news.category}
              imageSrc={news.image_default}
              imageSrcset={imageSrcset}
              imageSizes={imageSizes}
              imageAlt={news.portrait_alt || ""}
              imageWidth={width}
              heading={news.name}
              url={isExternal ? news.external_url : `/news/${news.slug}`}
              cta={isExternal ? "Read Article" : "Learn More"}
              isExternal={isExternal}
            />
          </Item>
        );
      })}
    </Grid>
  );
};

List.propTypes = {
  newsList: PropTypes.array,
};

export default List;
